import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService } from '@/core/api/base-service';
import { ApiConfiguration } from '@/core/api/api-configuration';
import { environment } from '../../../../../../../environments/environment';
import { SICOM_PATHS } from 'src/sicom-paths';
import { AtualizarIndicadoresResponse, IndiceValorResponse, SalarioMinimoResponse } from './indicadores.model';

@Injectable({ providedIn: 'root' })
export class IndicadoresService extends BaseService {
    private readonly PATH = SICOM_PATHS.financeiro.arrecadacao.indicadores;

    constructor(config: ApiConfiguration, http: HttpClient) {
        super(config, http, environment.apis.apiSicom);
    }

    listarInpc(): Observable<IndiceValorResponse[]> {
        return this.http.get<IndiceValorResponse[]>(`${this.rootUrl}${this.PATH}/inpc`);
    }

    listarSelic(): Observable<IndiceValorResponse[]> {
        return this.http.get<IndiceValorResponse[]>(`${this.rootUrl}${this.PATH}/selic`);
    }

    listarSalarioMinimo(): Observable<SalarioMinimoResponse[]> {
        return this.http.get<SalarioMinimoResponse[]>(`${this.rootUrl}${this.PATH}/salario-minimo`);
    }

    /**
     * Solicita a atualização dos indicadores econômicos no backend (busca novos valores
     * de INPC, SELIC e salário mínimo a partir de fontes externas).
     */
    atualizar(): Observable<AtualizarIndicadoresResponse> {
        return this.http.post<AtualizarIndicadoresResponse>(`${this.rootUrl}${this.PATH}/atualizar`, {});
    }
}
